import React from "react";
import Lottie from "lottie-react";
import { comingSoon } from "@/assets/lottie";

const ComingSoon = (params: {
  id?: string;
  buttonClassName?: string;
  buttonEl?: JSX.Element;
  contentOnly?: boolean;
}) => {
  if (params.contentOnly)
    return (
      <Lottie
        className="max-xl:order-1 relative"
        animationData={comingSoon}
        loop={true}
      />
    );
  return (
    <>
      <label htmlFor={params.id} className={params.buttonClassName}>
        {params.buttonEl}
      </label>
      <input type="checkbox" id={params.id} className="modal-toggle" />

      <div className="modal" role="dialog">
        <div className="modal-box">
          <Lottie
            className="max-xl:order-1 relative"
            animationData={comingSoon}
            loop={true}
          />
        </div>
        <label className="modal-backdrop" htmlFor={params.id}>
          Close
        </label>
      </div>
    </>
  );
};

export default ComingSoon;
